import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { faqs } from '../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-131" data-mp="1hdum2bw8wr6k">
      <div className="mx-auto max-w-3xl" data-id="element-132" data-mp="1cfjd03drykpe">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-133" data-mp="1ccdooqcyzmuq">
          ❓ Frequently asked questions
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-134" data-mp="254744fl7g4av">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-brand-100 bg-white" data-id="element-135" data-mp="205vqdtrsh9nd" data-mpi={index}>
                <h3 data-id="element-136" data-mp="opp1bp56z26q">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-137" data-mp="oq77pelkiwsd">
                    <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-138" data-mp="1pm1tbuz37wlp">{faq.q}</span>
                    <ChevronDownIcon className={['h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out', isOpen ? 'rotate-180' : ''].join(' ')} aria-hidden="true" data-id="element-139" data-mp="1ap12dtoq05oa" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-brand-100 px-5 py-4 text-[14.5px] leading-relaxed text-brand-900/75" data-id="element-140" data-mp="s0m6ot3gk3h5">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-141" data-mp="mzq6apibezgh">
          <CTAButton label="Get instant access now" note="$27 USD · 7-day money-back guarantee" data-id="element-142" data-mp="mzgh3453gwbu" />
        </div>
      </div>
    </section>;
}